const PERMISSIONS = {
  ANY_PERMISSION:'any',
  NO_PERMISSION:'',
  API_KEYS: {
    CREATE: 'api-keys-create',
    DELETE: 'api-keys-delete',
    EDIT: 'api-keys-edit',
    LIST: 'api-keys-list'
  },
  ACTIVITIES: {
    CREATE: 'activities-create',
    DELETE: 'activities-delete',
    EDIT: 'activities-edit',
    LIST: 'activities-list',
    IMPORT_STANDARD_PRICING: 'activities-import_standard_pricing',
    EXPORT: 'activities-export',
    IMPORT: 'activities-import'
  },
  PRICING: {
    CREATE: 'pricing-create',
    DELETE: 'pricing-delete',
    EDIT: 'pricing-edit',
    LIST: 'pricing-list'
  },
  APPROVAL: {
    CREATE: 'approval-create',
    DELETE: 'approval-delete',
    EDIT: 'approval-edit',
    LIST: 'approval-list'
  },
  APPOINTMENT: {
    CREATE: 'appointment-create',
    DELETE: 'appointment-delete',
    EDIT: 'appointment-edit',
    LIST: 'appointment-list'
  },
  WHITE_BOARD: {
    CREATE: 'white-board-create',
    DELETE: 'white-board-delete',
    EDIT: 'white-board-edit',
    LIST: 'white-board-list',
    SCAN_BARCODE: 'white-board-scan_barcode',
    ADD_VISIT: 'white-board-add_visit',
    ADD_PATIENT: 'white-board-add_patient',
    FOLLOW_UP: 'white-board-follow_up',
    ADD_LAB: 'white-board-add_lab',
    ADD_PHYSICAL_SCREEN: 'white-board-add_physical_screen',
    SEND_MESSAGE: 'white-board-send_message'
  },  
  BASIC_PHYSICAL: {
    CREATE: 'basic-physical-create',
    DELETE: 'basic-physical-delete',
    EDIT: 'basic-physical-edit',
    LIST: 'basic-physical-list'
  },
  CLINIC: {
    CREATE: 'clinic-create',
    DELETE: 'clinic-delete',
    EDIT: 'clinic-edit',
    LIST: 'clinic-list'
  },
  CLINIC_DEPARTMENT: {
    CREATE: 'clinic-department-create',
    DELETE: 'clinic-department-delete',
    EDIT: 'clinic-department-edit',
    LIST: 'clinic-department-list'
  },
  COMPANY: {
    CREATE: 'company-create',
    DELETE: 'company-delete',
    EDIT: 'company-edit',
    LIST: 'company-list'
  },
  COMPANY_DIVISION: {
    CREATE: 'company-division-create',
    DELETE: 'company-division-delete',
    EDIT: 'company-division-edit',
    LIST: 'company-division-list'
  },
  CONSENT: {
    CREATE: 'consent-create',
    DELETE: 'consent-delete',
    EDIT: 'consent-edit',
    LIST: 'consent-list'
  },
  CONTRACT:{
    CREATE: 'contract-create',
    DELETE: 'contract-delete',
    EDIT: 'contract-edit',
    LIST: 'contract-list'
  },
  DASHBOARD: {
    CREATE: 'dashboard-create',
    DELETE: 'dashboard-delete',
    EDIT: 'dashboard-edit',
    LIST: 'dashboard-list',
    INCOMPLETE_CHARTING_TABLE: 'dashboard-incomplete_charting_table',
    REVIEW_COMPLETED_ORDERS_TABLE: 'dashboard-review_completed_orders_table',
    DEFICIENT_CHARTING_TABLE: 'dashboard-deficient_charting_table',
    MESSAGES_TASKS_TABLE: 'dashboard-messages_tasks_table',
    OVER_ALL_VISITS: 'dashboard-over_all_visits'
  },
  MERGE_PATIENT: {
    LIST: 'merge-patient-list',
    CREATE: 'merge-patient-create',
    EDIT: 'merge-patient-edit',
    DELETE: 'merge-patient-delete'
  },
  EMPLOYEE: {
    CREATE: 'employee-create',
    DELETE: 'employee-delete',
    EDIT: 'employee-edit',
    LIST: 'employee-list',
    SEND_MESSAGE: 'employee-send-message',
    VISIT_HISTORY: 'employee-visit_history'
  },
  INSURANCE: {
    CREATE: 'insurance-create',
    DELETE: 'insurance-delete',
    EDIT: 'insurance-edit',
    LIST: 'insurance-list'
  },
  WORK_COMP_INSURANCE: {
    CREATE: 'work-comp-insurance-create',
    DELETE: 'work-comp-insurance-delete',
    EDIT: 'work-comp-insurance-edit',
    LIST: 'work-comp-insurance-list'
  },
  INVOICE: {
    CREATE: 'invoice-create',
    DELETE: 'invoice-delete',
    EDIT: 'invoice-edit',
    LIST: 'invoice-list'
  },
  LAB: {
    CREATE: 'lab-create',
    DELETE: 'lab-delete',
    EDIT: 'lab-edit',
    LIST: 'lab-list'
  },
  LOOKUP: {
    CREATE: 'lookup-create',
    DELETE: 'lookup-delete',
    EDIT: 'lookup-edit',
    LIST: 'lookup-list'
  },
  ORGANIZATION: {
    CREATE: 'organization-create',
    DELETE: 'organization-delete',
    EDIT: 'organization-edit',
    LIST: 'organization-list'
  },
  PROVIDER: {
    CREATE: 'provider-create',
    DELETE: 'provider-delete',
    EDIT: 'provider-edit',
    LIST: 'provider-list'
  },
  RESULT: {
    CREATE: 'result-create',
    DELETE: 'result-delete',
    EDIT: 'result-edit',
    LIST: 'result-list'
  },
  ROLE: {
    CREATE: 'role-create',
    DELETE: 'role-delete',
    EDIT: 'role-edit',
    LIST: 'role-list'
  },
  USER: {
    CREATE: 'user-create',
    DELETE: 'user-delete',
    EDIT: 'user-edit',
    LIST: 'user-list'
  },
  VACCINE_ADMINISTRATION: {
    CREATE: 'vaccine-administration-create',
    DELETE: 'vaccine-administration-delete',
    EDIT: 'vaccine-administration-edit',
    LIST: 'vaccine-administration-list'
  },
  VISITS: {
    CREATE: 'visits-create',
    DELETE: 'visits-delete',
    EDIT: 'visits-edit',
    LIST: 'visits-list',
    SCAN_BARCODE: 'visits-scan_barcode',
    // ADD_VISIT: 'visits-add_visit',
    // ADD_PATIENT: 'visits-add_patient',
    FOLLOW_UP: 'visits-follow_up',
    VIEW_CHART: 'visits-view_chart',
    DOWNLOAD_CLEARANCE_REPORT: 'visits-download_clearance_report',
    PRINT_INTAKE_PAPERWORK: 'visits-print_intake_paperwork',
    PRINT_CONSENTS: 'visits-print_consents',
    RESEND_PATIENT_FORMS: 'visits-resend_patient_forms',
    PATIENT_FORMS_KIOSK: 'visits-patient_forms_kiosk',
    SEND_MESSAGE: 'visits-send_message',
    SEND_EMAIL: 'visits-send_email',
    PRINT_EDITED_CHARTNOTE: 'visits-print_edited_chartnote',
    PRINT_CHARTNOTE: 'visits-print_chartnote',
    SUBMIT_TO_DAISY_BILL: 'visits-submit_to_daisy_bill'
  },
  CPT: {
    CREATE: 'cpt-create',
    DELETE: 'cpt-delete',
    EDIT: 'cpt-edit',
    LIST: 'cpt-list'
  },
  CSV_IMPORT: {
    CREATE: 'csv-import-create',
    DELETE: 'csv-import-delete',
    EDIT: 'csv-import-edit',
    LIST: 'csv-import-list'
  },
  VISIT_SCHEDULE: {
    CREATE: 'visit-schedule-create',
    DELETE: 'visit-schedule-delete',
    EDIT: 'visit-schedule-edit',
    LIST: 'visit-schedule-list'
  },
  INCIDENT: {
    CREATE: 'incident-create',
    DELETE: 'incident-delete',
    EDIT: 'incident-edit',
    LIST: 'incident-list'
  },
  STATE_FORMS: {
    CREATE: 'state-form-create',
    DELETE: 'state-form-delete',
    EDIT: 'state-form-edit',
    LIST: 'state-form-list'
  },
  FAILED_EZ_READER: {
    CREATE: 'failed-ez-reader-create',
    DELETE: 'failed-ez-reader-delete',
    EDIT: 'failed-ez-reader-edit',
    LIST: 'failed-ez-reader-list'
  },
  NOTIFICATION_LOG: {
    CREATE: 'notification-log-create',
    DELETE: 'notification-log-delete',
    EDIT: 'notification-log-edit',
    LIST: 'notification-log-list'
  },
  HL7_LOG: {
    CREATE: 'hl7-log-create',
    DELETE: 'hl7-log-delete',
    EDIT: 'hl7-log-edit',
    LIST: 'hl7-log-list',
    FETCH_RESULT: 'hl7-log-fetch_result'
  },
  EMR_CONFIGURATION: {
    CREATE: 'emr-configuration-create',
    DELETE: 'emr-configuration-delete',
    EDIT: 'emr-configuration-edit',
    LIST: 'emr-configuration-list'
  },
  RANDOM_GENERATOR: {
    CREATE: 'random-generator-create',
    DELETE: 'random-generator-delete',
    EDIT: 'random-generator-edit',
    LIST: 'random-generator-list'
  },
  ICD10: {
    CREATE: 'icd10-create',
    DELETE: 'icd10-delete',
    EDIT: 'icd10-edit',
    LIST: 'icd10-list'
  },
   REPORTS: {
    CREATE: 'reports-create',
    DELETE: 'reports-delete',
    EDIT: 'reports-edit',
    LIST: 'reports-list'
  },
  LAB_PANEL: {
    CREATE: 'lab-panel-create',
    DELETE: 'lab-panel-delete',
    EDIT: 'lab-panel-edit',
    LIST: 'lab-panel-list'
  },
   TUTORIAL_VIDEO: {
    CREATE: 'tutorial-video-create',
    DELETE: 'tutorial-video-delete',
    EDIT: 'tutorial-video-edit',
    LIST: 'tutorial-video-list'
  },
  NOTIFICATION_TEMPLATE: {
    CREATE: 'notification-template-create',
    DELETE: 'notification-template-delete',
    EDIT: 'notification-template-edit',
    LIST: 'notification-template-list'
  },
  DATA_PERMISSION_TEMPLATE: {
    CREATE: 'data-permission-template-create',
    DELETE: 'data-permission-template-delete',
    EDIT: 'data-permission-template-edit',
    LIST: 'data-permission-template-list'
  },
  REFERRAL_PROVIDER: {
    CREATE: 'referral-provider-create',
    DELETE: 'referral-provider-delete',
    EDIT: 'referral-provider-edit',
    LIST: 'referral-provider-list'
  },
  AI_DIAGNOSIS_LOGS: {
    CREATE: 'ai-diagnosis-logs-create',
    DELETE: 'ai-diagnosis-logs-delete',
    EDIT: 'ai-diagnosis-logs-edit',
    LIST: 'ai-diagnosis-logs-list'
  },
  DOT_SUBMISSION_LOGS: {
    LIST: 'dot-submission-logs-list'
  },
  WORK_STATUS: {
    CREATE: 'work-status-create',
    DELETE: 'work-status-delete',
    EDIT: 'work-status-edit',
    LIST: 'work-status-list',
    PRINT: 'work-status-print',
    SEND_EMAIL: 'work-status-send_email',
    SEND_SMS: 'work-status-send_sms',
    SEND_MESSAGE: 'work-status-send_message'
  },
  AUDIT_LOG: {
    CREATE: 'audit-log-create',
    DELETE: 'audit-log-delete',
    EDIT: 'audit-log-edit',
    LIST: 'audit-log-list'
  },
  COMPLIANCE_MONITOR: {
    CREATE: 'compliance-monitor-create',
    DELETE: 'compliance-monitor-delete',
    EDIT: 'compliance-monitor-edit',
    LIST: 'compliance-monitor-list'
  },
  SFTP_CONFIGURATION: {
    CREATE: 'sftp-configuration-create',
    DELETE: 'sftp-configuration-delete',
    EDIT: 'sftp-configuration-edit',
    LIST: 'sftp-configuration-list'
  },
  CLEARING_HOUSE: {
    CREATE: 'clearing-house-create',
    DELETE: 'clearing-house-delete',
    EDIT: 'clearing-house-edit',
    LIST: 'clearing-house-list'
  },
  HISTORICAL_VISIT: {
    CREATE: 'historical-visit-create',
    DELETE: 'historical-visit-delete',
    EDIT: 'historical-visit-edit',
    LIST: 'historical-visit-list'
  }

};

export default PERMISSIONS;
